var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 25",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-63,-140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-stats",
    transform: "matrix(1.03469,0,0,1.03469,-2.18558,21.745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 114.805,
    width: 23.195,
    height: 23.195,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.483236,0,0,0.536929,34.4891,62.6152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101,136.8L65,136.8C63.895,136.8 63,135.994 63,135L63,117C63,116.006 63.895,115.2 65,115.2L75,115.2L75,102.6C75,101.606 75.895,100.8 77,100.8L89,100.8C90.105,100.8 91,101.606 91,102.6L91,109.8L101,109.8C102.105,109.8 103,110.606 103,111.6L103,135C103,135.994 102.105,136.8 101,136.8ZM75,118.8L67,118.8L67,133.2L75,133.2L75,118.8ZM87,111.6L87,104.4L79,104.4L79,133.2L87,133.2L87,111.6ZM91,133.2L99,133.2L99,113.4L91,113.4L91,133.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStats);
export default __webpack_public_path__ + "static/media/icon-stats.297ad7ad583ad54d4f0f6621d01093cf.svg";
export { ForwardRef as ReactComponent };